import { render, staticRenderFns } from "./InfectiousMark.vue?vue&type=template&id=b3a725d0&scoped=true"
import script from "./InfectiousMark.vue?vue&type=script&lang=js"
export * from "./InfectiousMark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a725d0",
  null
  
)

export default component.exports